<script>
    let clsPrefix = "sui-auto-center";
</script>

<div class={clsPrefix}>
    <slot />
</div>

<style lang="less">
    @import "./AutoCenter.less";
</style>
